import axios from "axios";
import {updateMicrocart} from "./microcart";
import app from "../_app";

const quickProductForms = [...document.querySelectorAll('.js-quick-product-form')];
const language = document.querySelector('html').getAttribute('lang');

const checkIfProductExists = async (id) => {
    let response = await axios.get(`${Shopify.routes.root}cart.js`);

    if (response.status === 200) {
        const cartPrice = document.querySelector('.js-cart-price');
        let data = response.data.items;

        if (cartPrice) {
            cartPrice.innerHTML = app.currency(response.data.total_price, false);
        }

        return data.some(product => product.id === Number(id));
    }

    return false;
}

const updateQuickProductForm = async quickProductForm => {
    const submitButton = quickProductForm.querySelector('.js-quick-product-form-button');
    const productID = quickProductForm.querySelector('input[name="id"]').value;
    const productExists = await checkIfProductExists(productID);

    // Clear previous event listeners
    const newButton = document.createElement('button');
    if (productExists) {
        newButton.type = 'button';
        newButton.dataset.action = 'remove';
        newButton.classList.add('btn', 'btn--xl', 'btn--inverted');
        newButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#232322" viewBox="0 -960 960 960"><path d="m291-240-51-51 189-189-189-189 51-51 189 189 189-189 51 51-189 189 189 189-51 51-189-189-189 189Z"/></svg>`;
        newButton.addEventListener('click', () => {
            quickOrder(`${quickProductForm.getAttribute('data-action')}change`, productID, 0);
        });
    } else {
        let addText = 'Toevoegen';
        if (language === 'de') {
            addText = 'Hinzufügen';
        } else if (language === 'fr') {
            addText = 'Ajouter';
        } else if (language === 'en') {
            addText = 'Add';
        }
        newButton.type = 'button';
        newButton.dataset.action = 'add';
        newButton.classList.add('btn', 'btn--xl', 'btn--primary');
        newButton.textContent = addText;
        newButton.addEventListener('click', () => {
            quickOrder(`${quickProductForm.getAttribute('data-action')}add`, productID, 1);
        });
    }

    // Replace old button with the new one
    submitButton.innerHTML = '';
    submitButton.appendChild(newButton);
}

quickProductForms.map(async quickProductForm => {
    await updateQuickProductForm(quickProductForm);
});

const quickOrder = async (action, id, quantity) => {
    const formData = new FormData();
    formData.set('id', id);
    formData.set('quantity', quantity);

    let {status} = await axios.post(`${action}.js`, formData);

    if (status === 200) {
        location.reload();
    }
}
